function functionWithTimeout(callback, timeout) {
  let called = false;
  function fn() {
    if (!called) {
      called = true;
      callback();
    }
  }
  setTimeout(fn, timeout || 1000);
  return fn;
}

function trackOutboundLink(event) {
  if (typeof ga === 'undefined') return;

  event.preventDefault();

  const category = 'Outbound Links';
  const href = this.href;
  const uid = this.dataset.uid;

  ga('send', 'event', {
    eventCategory: category,
    eventAction: 'click',
    eventLabel: href,
    eventValue: uid,
    hitCallback: functionWithTimeout(function () {
      // Intentionally empty: popup opened via setTimeout below.
    })
  });

  setTimeout(function () {
    window.open(href, '_new_tab');
  }, 200);
  return false;
}

let outboundBannerLinksBound = false;

export function bindOutboundBannerLinks() {
  if (outboundBannerLinksBound) return;
  outboundBannerLinksBound = true;

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.outbound-banner-link');
    if (!link) return;
    trackOutboundLink.call(link, event);
  });
}
